import React, { useRef } from 'react';

export default function ChatComposer({ value, onChange, onSend, disabled, placeholder }) {
  const textareaRef = useRef(null);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (value.trim()) onSend();
    }
  };

  const handleInput = (e) => {
    onChange(e.target.value);
    const el = textareaRef.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }
  };

  return (
    <div className="sa-composer">
      <div className="sa-composer-row">
        <textarea
          ref={textareaRef}
          className="sa-composer-input"
          rows={1}
          value={value}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          disabled={disabled}
          placeholder={placeholder || 'Scrivi la tua risposta…'}
          aria-label="Scrivi la tua risposta"
        />
        <button
          type="button"
          className="sa-composer-send"
          onClick={onSend}
          disabled={disabled || !value.trim()}
          aria-label="Invia risposta"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M3 12L21 3L14 21L11 13L3 12Z" fill="currentColor" />
          </svg>
        </button>
      </div>
      <p className="sa-composer-hint">Invio per inviare · Maiusc+Invio per andare a capo</p>
    </div>
  );
}
